const EmployeeInfoField = (label: string, subLabel: string, field: string) => (
  <span className="form-label small-text">
    {label}<span className="sub-form-label small-text">({subLabel})</span>：{field}
  </span>
);
export default EmployeeInfoField;